<template>
    <div class="pb-5">
        <data-table ref="euthanasiaReasons"
                    :api-route="backendApiRoute"
                    :api-view-set="table.apiViewSet"
                    :name="table.name"
                    :columns="table.columns"
                    :search="table.search"
                    :filters="table.filters ? table.filters : []"
                    :actions="table.actions"
                    :orderings="table.orderings"
                    :initial-orderings="table.initialOrderings"
                    :row-actions="table.rowActions"
                    :key="table.key">
        </data-table>
    </div>
</template>

<script>
import DataTable from "@/components/Table/DataTable.vue";
import {mapGetters} from "vuex";
import api from "@/api";
import actions from "@/components/Table/actions";
import {EuthanasiaReason} from "@/pages/AppPages/Catalogs/EuthanasiaReasons/euthanasiaReason";

export default {
    name: "EuthanasiaReasonList",
    components: {DataTable},
    computed: {
        ...mapGetters(['ability']),
        backendApiRoute() { return api.euthanasiaReasons.default.list() },
    },
    data() {
        return {
            table: {
                name: 'euthanasia-reasons-table',
                apiViewSet: api.euthanasiaReasons.default,
                key: 'euthanasia-reasons-table',
                search: true,
                columns: [
                    {
                        name: 'number',
                        title: 'Порядковый номер',
                        alwaysVisible: true,
                        to: {
                            idColumn: 'id',
                            routeName: 'euthanasiaReasonDetail',
                            prependWithN: true
                        }
                    },
                    {
                        name: 'name',
                        title:  'Наименование'},
                ],
                orderings: [
                    'number',
                    'name',
                ],
                actions: [],
                rowActions: [],
            }
        }
    },
    mounted() {
        const canCreate = this.ability.can('create', 'EuthanasiaReason');
        if (canCreate) {
            this.table.actions.push(
                actions.create(() => {
                        this.$router.push({name: 'euthanasiaReasonCreate'})
                    }, canCreate
                )
            );
        }

        if (this.ability.can('destroy', 'EuthanasiaReason')) {
            this.table.rowActions.push(
                new actions.objectDelete(EuthanasiaReason))
        }
    }

}
</script>

<style scoped>

</style>